var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTiktokGrey = function SvgTiktokGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tiktok-grey-icon",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M0,0H18V18H0Z",
    fill: "#7c98b6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_286",
    "data-name": "Group 286",
    transform: "translate(3.821 2.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M213.565,93.671v1.746a7.787,7.787,0,0,1-1.376-.188,5.231,5.231,0,0,1-1.345-.553l-.392-.258v4.6a4.655,4.655,0,0,1-.273,1.43,4.179,4.179,0,0,1-2.145,2.287,4.1,4.1,0,0,1-1.71.376,4.237,4.237,0,0,1-2.3-.688l-.005-.005a4.6,4.6,0,0,1-.324-.367,4.451,4.451,0,0,1-.615-1.118h0a4.49,4.49,0,0,1-.243-1.487,4.088,4.088,0,0,1,.5-1.884,4.445,4.445,0,0,1,.967-1.182,4.056,4.056,0,0,1,1.149-.68,3.836,3.836,0,0,1,1.426-.3v1.767a1.938,1.938,0,0,0-1.615.229,1.893,1.893,0,0,0-.058,3.12c.079.052.155.1.231.139a1.918,1.918,0,0,0,2.328.594,1.788,1.788,0,0,0,.982-1.08,2.608,2.608,0,0,0,.1-.893V90.6h1.634a3.106,3.106,0,0,0,.748,1.536,3.628,3.628,0,0,0,.665.561,3.441,3.441,0,0,0,.912.7,3.476,3.476,0,0,0,.765.279Z",
    transform: "translate(-202.832 -90.6)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTiktokGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tiktok-grey.187efd4d.svg";
export { ForwardRef as ReactComponent };